import React, { useState } from "react";
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Alert, AlertDescription } from "../components/ui/alert";
import User from "../database/User";

export default function MfaVerify({ mfaChallengeToken, email, onBack, onSuccess }) {
    const [code, setCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [resending, setResending] = useState(false);
    const [resent, setResent] = useState(false);
    const handleVerify = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            await User.verifyMfa(mfaChallengeToken, code);
            onSuccess();
        } catch (err) {
            setError(err.message || "Invalid code. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleResend = async () => {
        setResending(true);
        setError("");
        try {
            await User.requestMfaCode(mfaChallengeToken, email);
            setResent(true);
            setTimeout(() => setResent(false), 3000);
        } catch (err) {
            setError(err.message || "Failed to resend code.");
        } finally {
            setResending(false);
        }
    };

    return (
        <Card>
            <CardHeader>
                <CardTitle>Check your email</CardTitle>
                <CardDescription>
                    We sent a verification code to {email}
                </CardDescription>
            </CardHeader>
            <form onSubmit={handleVerify}>
                <CardContent className="space-y-4">
                    {error && (
                        <Alert variant="destructive">
                            <AlertDescription>{error}</AlertDescription>
                        </Alert>
                    )}
                    {resent && (
                        <Alert>
                            <AlertDescription>A new code has been sent.</AlertDescription>
                        </Alert>
                    )}
                    <div className="space-y-2">
                        <Label htmlFor="mfaCode">Verification Code</Label>
                        <Input
                            id="mfaCode"
                            type="text"
                            inputMode="numeric"
                            maxLength={6}
                            placeholder="Enter 6-digit code"
                            value={code}
                            onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
                            required
                            disabled={loading}
                            autoFocus
                        />
                    </div>
                </CardContent>
                <CardFooter className="flex flex-col space-y-2">
                    <Button type="submit" className="w-full" disabled={loading || code.length !== 6}>
                        {loading ? "Verifying..." : "Verify"}
                    </Button>
                    <button
                        type="button"
                        onClick={handleResend}
                        disabled={resending}
                        className="text-sm text-muted-foreground hover:text-primary underline"
                    >
                        {resending ? "Sending..." : "Resend code"}
                    </button>
                    <button
                        type="button"
                        onClick={onBack}
                        className="text-sm text-muted-foreground hover:text-primary underline"
                    >
                        Back to Login
                    </button>
                </CardFooter>
            </form>
        </Card>
    );
}
